import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Elements } from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";
import "./CheckoutForm.css";
import axios from "axios";
import cookie from "react-cookies";
import { baseURL } from "../axios/AxiosAut";
import Swal from "sweetalert2";
import "animate.css";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe(
  "pk_test_51KEASpDu1x94b5L5HBG8TU7EQPTwMxf1duCRgccWypSc5aBh14P3P4JyqEwuHAtdmdrWtAr9U8iNbRci8f5hAkd400OBmOj3Wj"
);

function StripeWrapper(props) {
  const { setOpen } = props;
  return (
    <>
      <Elements stripe={stripePromise}>
        <CheckoutForm setOpen={setOpen} />
      </Elements>
    </>
  );
}
export default StripeWrapper;

const CheckoutForm = (setOpen) => {
  const SubscriptionDetail = useSelector(
    (state) => state.company.subscriptionDetail
  );
  const Navigate = useNavigate;
  const companyID = useSelector((state) => state.company.companyDetail.id);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [IsSubmitting, setIsSubmitting] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  // Handle real-time validation errors from the CardElement.
  const handleChange = (event) => {
    if (event.error) {
      setError(event.error.message);
    } else {
      setError("");
    }
  };

  //Add subscription
  const HandleSubscriptionDetail = () => {
    console.log("SubscriptionDetail", SubscriptionDetail);
    axios
      .post(
        `${baseURL}api/verify_company_account/`,
        {
          company_id: companyID,
          subscription_renewal_period:
            SubscriptionDetail.subscription_renewal_period,
          number_of_users: SubscriptionDetail.number_of_users,
          package: SubscriptionDetail.package,
          price_per_month: SubscriptionDetail.price_per_month,
        },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${cookie.load("access_token")}`,
          },
        }
      )
      .then((res) => {
        console.log("subscription successfully added", res.data);
        setIsSubmitting(false);
        // Swal.fire({
        //   title: "Congratulations",
        //   text: "Subscription Successfully added",
        //   icon: "success",
        //   timer: 3000,
        //   showConfirmButton: false,
        //   showClass: {
        //     popup: "animate__animated animate__fadeInDown",
        //   },
        //   hideClass: {
        //     popup: "animate__animated animate__fadeOutUp",
        //   },
        // });
        // setOpen(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Handle form submission.
  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    event.preventDefault();
    const card = elements.getElement(CardElement);
    // add these lines
    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: card,
    });
    console.log("payment", paymentMethod);
    axios
      .post(
        `${baseURL}api/save-stripe-info/`,
        {
          email,
          payment_method_id: paymentMethod.id,
          number_of_users: SubscriptionDetail.number_of_users,
          package: SubscriptionDetail.package,
        },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${cookie.load("access_token")}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        HandleSubscriptionDetail();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <form onSubmit={handleSubmit} className="stripe-form">
      <div className="form-col">
        <label htmlFor="email">Email Address</label>
        <div>
          <input
            className="form-input"
            id="email"
            name="email"
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
        </div>
      </div>
      <div className="card">
        <label htmlFor="card-element">Credit or debit card</label>
        <CardElement
          id="card-element"
          onChange={handleChange}
          className="card-no"
        />
        <div className="card-errors" role="alert">
          {error}
        </div>
      </div>
      {!IsSubmitting ? (
        <button
          type="submit"
          className="font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
        >
          Confirm
        </button>
      ) : (
        <button
          disabled
          className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
        >
          <div className="flex items-center justify-center space-x-2 animate-pulse">
            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
          </div>
        </button>
      )}
    </form>
  );
};
